// extracted by mini-css-extract-plugin
module.exports = {"hotspotComponentWrapper":"xM","slider-wrapper":"xN"};